
import {
  Card,
  Container,
  Table,
  TableContainer,
  Typography
} from '@mui/material';
import DataTableRow from '@src/components/data-table/data-row';
import Scrollbar from '@src/components/scrollbar';
import { TABLE_HEAD_RNG_DRAW_RESULT } from '@src/utils/mockdata/table-headers';
import { useRNG } from '../provider';
import TableHeader from './table-header';
import TableRowItem from './table-row';

const DrawResult = () => {
  const { rngResult, isLoading } = useRNG();

  return (
    <Container>
      <Typography alignSelf={"center"} textAlign={"center"} fontSize={"22px"} fontWeight={700} mb={1}>DRAW RESULT</Typography>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800, p:2 }}>
            <Table>
              <TableHeader
                disableButton
                headLabel={TABLE_HEAD_RNG_DRAW_RESULT} />
              <DataTableRow
                colSpan={7}
                isLoading={isLoading}
                headers={TABLE_HEAD_RNG_DRAW_RESULT}
                data={rngResult?.winners ?? []}
                renderItem={({ item, index }: any) => {
                  return <TableRowItem 
                    key={`${index}`} {...item} />
                }} />
            </Table>
          </TableContainer>
        </Scrollbar>
      </Card>
    </Container>
  );
}

export default DrawResult;
